<template>
  <hr class="separator" />
</template>

<script lang="ts">
  export default defineNuxtComponent({
    name: 'BaseSeparator',
  });
</script>

<style lang="scss" scoped>
  .separator {
    height: 2px;
    display: block;
    border: none;
    background: #000000;
  }
</style>
